import { useEffect, RefObject } from 'react';
import { getDocumentActionAriaLabel } from './documentAccessibility';

export const useFilePondDocument = (
  pondRef: RefObject<any>,
  documentName?: string | null,
  documentType?: string | null,
  typeTitle?: string | null,
  enabled = true
): void => {
  const chooseLabel = getDocumentActionAriaLabel('choose', documentName, documentType, typeTitle);

  useEffect(() => {
    if (!enabled) return;

    const root = pondRef.current?.element;
    if (!root) return;

    const applyLabels = () => {
      const browseButton = root.querySelector('.filepond--browser') as HTMLElement | null;
      const labelAction = root.querySelector('.filepond--label-action') as HTMLElement | null;
      const dropLabel = root.querySelector('.filepond--drop-label') as HTMLElement | null;

      browseButton?.setAttribute('aria-label', chooseLabel);
      labelAction?.setAttribute('aria-label', chooseLabel);
      dropLabel?.setAttribute('aria-label', chooseLabel);
    };

    applyLabels();
    const observer = new MutationObserver(applyLabels);
    observer.observe(root, { childList: true, subtree: true, attributes: true });

    return () => observer.disconnect();
  }, [chooseLabel, enabled, pondRef]);
};
